'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SWITCH_BUNDLE_ID = exports.SWITCH_BUNDLE_ID = 'SWITCH_BUNDLE_ID';
var SWITCH_API_ENDPOINT = exports.SWITCH_API_ENDPOINT = 'SWITCH_API_ENDPOINT';
var LOAD_APP_CONFIGURATION_START = exports.LOAD_APP_CONFIGURATION_START = 'LOAD_APP_CONFIGURATION_START';
var LOAD_APP_CONFIGURATION_SUCCESS = exports.LOAD_APP_CONFIGURATION_SUCCESS = 'LOAD_APP_CONFIGURATION_SUCCESS';
var LOAD_APP_CONFIGURATION_FAILURE = exports.LOAD_APP_CONFIGURATION_FAILURE = 'LOAD_APP_CONFIGURATION_FAILURE';

var STAGING_LOAD_APPS_START = exports.STAGING_LOAD_APPS_START = 'STAGING_LOAD_APPS_START';
var STAGING_LOAD_APPS_SUCCESS = exports.STAGING_LOAD_APPS_SUCCESS = 'STAGING_LOAD_APPS_SUCCESS';
var STAGING_LOAD_APPS_FAILURE = exports.STAGING_LOAD_APPS_FAILURE = 'STAGING_LOAD_APPS_FAILURE';

var LOAD_MERCHANT_INFO_START = exports.LOAD_MERCHANT_INFO_START = 'LOAD_MERCHANT_INFO_START';
var LOAD_MERCHANT_INFO_SUCCESS = exports.LOAD_MERCHANT_INFO_SUCCESS = 'LOAD_MERCHANT_INFO_SUCCESS';
var LOAD_MERCHANT_INFO_FAILURE = exports.LOAD_MERCHANT_INFO_FAILURE = 'LOAD_MERCHANT_INFO_FAILURE';

var LOAD_BOOKING_RUSHES_START = exports.LOAD_BOOKING_RUSHES_START = 'LOAD_BOOKING_RUSHES_START';
var LOAD_BOOKING_RUSHES_SUCCESS = exports.LOAD_BOOKING_RUSHES_SUCCESS = 'LOAD_BOOKING_RUSHES_SUCCESS';
var LOAD_BOOKING_RUSHES_FAILURE = exports.LOAD_BOOKING_RUSHES_FAILURE = 'LOAD_BOOKING_RUSHES_FAILURE';

var UPDATE_CONNECTION_INFO = exports.UPDATE_CONNECTION_INFO = 'UPDATE_CONNECTION_INFO';

var SET_ENVIRONMENT = exports.SET_ENVIRONMENT = 'SET_ENVIRONMENT';

var LOAD_MENU_START = exports.LOAD_MENU_START = 'LOAD_MENU_START';
var LOAD_MENU_SUCCESS = exports.LOAD_MENU_SUCCESS = 'LOAD_MENU_SUCCESS';
var LOAD_MENU_FAILURE = exports.LOAD_MENU_FAILURE = 'LOAD_MENU_FAILURE';

var CREATE_CARD_TOKEN_START = exports.CREATE_CARD_TOKEN_START = 'CREATE_CARD_TOKEN_START';
var CREATE_CARD_TOKEN_SUCCESS = exports.CREATE_CARD_TOKEN_SUCCESS = 'CREATE_CARD_TOKEN_SUCCESS';
var CREATE_CARD_TOKEN_FAILURE = exports.CREATE_CARD_TOKEN_FAILURE = 'CREATE_CARD_TOKEN_FAILURE';

var MENU_CONFIGURE_ITEM = exports.MENU_CONFIGURE_ITEM = 'MENU_CONFIGURE_ITEM';
var MENU_CART_ADDITEM = exports.MENU_CART_ADDITEM = 'MENU_CART_ADDITEM';
var MENU_CART_RESTORE_FROM_ORDER = exports.MENU_CART_RESTORE_FROM_ORDER = 'MENU_CART_RESTORE_FROM_ORDER';
var MENU_CART_REMOVEITEM = exports.MENU_CART_REMOVEITEM = 'MENU_CART_REMOVEITEM';
var MENU_CART_RESET = exports.MENU_CART_RESET = 'MENU_CART_RESET';
var MENU_SHOW_ERRORS = exports.MENU_SHOW_ERRORS = 'MENU_SHOW_ERRORS';

var DELIVERY_ADDRESS_CHECK_START = exports.DELIVERY_ADDRESS_CHECK_START = 'DELIVERY_ADDRESS_CHECK_START';
var DELIVERY_ADDRESS_CHECK_SUCCESS = exports.DELIVERY_ADDRESS_CHECK_SUCCESS = 'DELIVERY_ADDRESS_CHECK_SUCCESS';
var DELIVERY_ADDRESS_CHECK_FAILURE = exports.DELIVERY_ADDRESS_CHECK_FAILURE = 'DELIVERY_ADDRESS_CHECK_FAILURE';

var DELIVERY_ADDRESS_UPDATE_START = exports.DELIVERY_ADDRESS_UPDATE_START = 'DELIVERY_ADDRESS_UPDATE_START';
var DELIVERY_ADDRESS_UPDATE_SUCCESS = exports.DELIVERY_ADDRESS_UPDATE_SUCCESS = 'DELIVERY_ADDRESS_UPDATE_SUCCESS';
var DELIVERY_ADDRESS_UPDATE_FAILURE = exports.DELIVERY_ADDRESS_UPDATE_FAILURE = 'DELIVERY_ADDRESS_UPDATE_FAILURE';

var DELIVERY_SET_DATE_TIME = exports.DELIVERY_SET_DATE_TIME = 'DELIVERY_SET_DATE_TIME';
var DELIVERY_DATE_DEFAULT = exports.DELIVERY_DATE_DEFAULT = 'TODAY';
var DELIVERY_TIME_DEFAULT = exports.DELIVERY_TIME_DEFAULT = 'ASAP';
var DELIVERY_TIME_ASAP = exports.DELIVERY_TIME_ASAP = 'ASAP';
var DELIVERY_SET_ADDRESS = exports.DELIVERY_SET_ADDRESS = 'DELIVERY_SET_ADDRESS';
var DELIVERY_CONFIRM_ADDRESS = exports.DELIVERY_CONFIRM_ADDRESS = 'DELIVERY_CONFIRM_ADDRESS';
var DELIVERY_RESET_ADDRESS = exports.DELIVERY_RESET_ADDRESS = 'DELIVERY_RESET_ADDRESS';
var DELIVERY_SET_ORDER_TYPE = exports.DELIVERY_SET_ORDER_TYPE = 'DELIVERY_SET_ORDER_TYPE';
var DELIVERY_SET_ORDER_DATA = exports.DELIVERY_SET_ORDER_DATA = 'DELIVERY_SET_ORDER_DATA';
var DELIVERY_UPDATE_ADDRESS_SNUMBER = exports.DELIVERY_UPDATE_ADDRESS_SNUMBER = 'DELIVERY_UPDATE_ADDRESS_SNUMBER';
var DELIVERY_UPDATE_EXTRA_INFO = exports.DELIVERY_UPDATE_EXTRA_INFO = 'DELIVERY_UPDATE_EXTRA_INFO';
var USER_LOCATION = exports.USER_LOCATION = 'USER_LOCATION';

var PAYMENT_SET_METHOD = exports.PAYMENT_SET_METHOD = 'PAYMENT';
var PAYMENT_METHOD_CC = exports.PAYMENT_METHOD_CC = 'credit-card';
var PAYMENT_UNHANDLED = exports.PAYMENT_UNHANDLED = 'unhandled';

var TAKEAWAY_SET_RESTAURANT = exports.TAKEAWAY_SET_RESTAURANT = 'TAKEAWAY_SET_RESTAURANT';
var ORDER_TYPE_DELIVERY = exports.ORDER_TYPE_DELIVERY = 'delivery';
var ORDER_TYPE_TAKEAWAY = exports.ORDER_TYPE_TAKEAWAY = 'takeAway';
var ORDER_RESET = exports.ORDER_RESET = 'ORDER_RESET';
var ORDER_RELOAD = exports.ORDER_RELOAD = 'ORDER_RELOAD';
var STORE_ORDER_START = exports.STORE_ORDER_START = 'STORE_ORDER_START';
var STORE_ORDER_SUCCESS = exports.STORE_ORDER_SUCCESS = 'STORE_ORDER_SUCCESS';
var STORE_ORDER_FAILURE = exports.STORE_ORDER_FAILURE = 'STORE_ORDER_FAILURE';
var UPDATE_CURRENTORDER = exports.UPDATE_CURRENTORDER = 'UPDATE_CURRENTORDER';
var ORDER_SET_CHECKOUT_FORM = exports.ORDER_SET_CHECKOUT_FORM = 'ORDER_SET_CHECKOUT_FORM';
var ORDER_ADD_VOUCHER = exports.ORDER_ADD_VOUCHER = 'ORDER_ADD_VOUCHER';
var ORDER_NO_VOUCHER = exports.ORDER_NO_VOUCHER = -1;
var ORDER_TOGGLE_UNHANDLED = exports.ORDER_TOGGLE_UNHANDLED = 'ORDER_TOGGLE_UNHANDLED';
var ORDER_NEW_CC_SETFORM = exports.ORDER_NEW_CC_SETFORM = 'ORDER_NEW_CC_SETFORM';
var ORDER_SET_CONFIRMED = exports.ORDER_SET_CONFIRMED = 'ORDER_SET_CONFIRMED';
var ORDER_FETCH_EXTRA_COSTS_START = exports.ORDER_FETCH_EXTRA_COSTS_START = 'ORDER_FETCH_EXTRA_COSTS_START';
var ORDER_FETCH_EXTRA_COSTS_SUCCESS = exports.ORDER_FETCH_EXTRA_COSTS_SUCCESS = 'ORDER_FETCH_EXTRA_COSTS_SUCCESS';
var ORDER_FETCH_EXTRA_COSTS_FAILURE = exports.ORDER_FETCH_EXTRA_COSTS_FAILURE = 'ORDER_FETCH_EXTRA_COSTS_FAILURE';

var VOUCHER_FORMAT_PERCENTAGE = exports.VOUCHER_FORMAT_PERCENTAGE = 'PERCENTAGE';
var VOUCHER_FORMAT_ABSOLUTE = exports.VOUCHER_FORMAT_ABSOLUTE = 'ABSOLUTE_VALUE';
var VOUCHER_FORMAT_FREE_ITEM = exports.VOUCHER_FORMAT_FREE_ITEM = 'FREE_ITEM';

var EXTRA_COST_TYPE_POSITIVE = exports.EXTRA_COST_TYPE_POSITIVE = 'positive';
var EXTRA_COST_TYPE_NEGATIVE = exports.EXTRA_COST_TYPE_NEGATIVE = 'negative';
var EXTRA_COST_TYPE_NEUTRAL = exports.EXTRA_COST_TYPE_NEUTRAL = 'neutral';

var SET_USER_LOCATION = exports.SET_USER_LOCATION = 'SET_USER_LOCATION';
var SET_BOOKING_RESTAURANT = exports.SET_BOOKING_RESTAURANT = 'SET_BOOKING_RESTAURANT';
var SET_BOOKING_DATE = exports.SET_BOOKING_DATE = 'SET_BOOKING_DATE';
var SET_BOOKING_TIME = exports.SET_BOOKING_TIME = 'SET_BOOKING_TIME';
var SET_BOOKING_SEATS = exports.SET_BOOKING_SEATS = 'SET_BOOKING_SEATS';
var BOOKING_RESET_END = exports.BOOKING_RESET_END = 'BOOKING_RESET_END';
var BOOKING_SET_FORM = exports.BOOKING_SET_FORM = 'BOOKING_SET_FORM';

var SET_PICKER_VISIBILITY = exports.SET_PICKER_VISIBILITY = 'SET_PICKER_VISIBILITY';
var BOOKING_PICKER_SEATS = exports.BOOKING_PICKER_SEATS = 'BOOKING_PICKER_SEATS';

var SET_RECOVERY_TOKEN = exports.SET_RECOVERY_TOKEN = 'SET_RECOVERY_TOKEN';
var UPDATE_RECOVERY_FORM_VALUE = exports.UPDATE_RECOVERY_FORM_VALUE = 'UPDATE_RECOVERY_FORM_VALUE';
var VERIFY_RECOVERY_TOKEN_START = exports.VERIFY_RECOVERY_TOKEN_START = 'VERIFY_RECOVERY_TOKEN_START';
var VERIFY_RECOVERY_TOKEN_SUCCESS = exports.VERIFY_RECOVERY_TOKEN_SUCCESS = 'VERIFY_RECOVERY_TOKEN_SUCCESS';
var VERIFY_RECOVERY_TOKEN_FAILURE = exports.VERIFY_RECOVERY_TOKEN_FAILURE = 'VERIFY_RECOVERY_TOKEN_FAILURE';
var RESET_PASSWORD_START = exports.RESET_PASSWORD_START = 'RESET_PASSWORD_START';
var RESET_PASSWORD_SUCCESS = exports.RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
var RESET_PASSWORD_FAILURE = exports.RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE';
var RESET_RECOVERY_PASSWORD_STATUS = exports.RESET_RECOVERY_PASSWORD_STATUS = 'RESET_RECOVERY_PASSWORD_STATUS';
var RECOVERY_EMAIL_REQUEST = exports.RECOVERY_EMAIL_REQUEST = 'RECOVERY_EMAIL_REQUEST';

var MENU_COLLAPSE_CATEGORIES = exports.MENU_COLLAPSE_CATEGORIES = 'MENU_COLLAPSE_CATEGORIES';
var MENU_UNCOLLAPSE_CATEGORIES = exports.MENU_UNCOLLAPSE_CATEGORIES = 'MENU_UNCOLLAPSE_CATEGORIES';

var PICKER_VISIBLE = exports.PICKER_VISIBLE = 'PICKER_VISIBLE';

var ORDER_TOGGLE_ASAP = exports.ORDER_TOGGLE_ASAP = 'ORDER_TOGGLE_ASAP';


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/ristoranti-frontend-lib/lib/constants.js
// module id = 9
// module chunks = 0